/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 52
() {

document.addEventListener('DOMContentLoaded', function() {
  var klaviyoKey = (window.theme && window.theme.settings && window.theme.settings.klaviyoKey) || '';
  var modal = document.getElementById('scandi-bis-modal');
  if (!modal || !klaviyoKey) return;
  var form = modal.querySelector('[data-klaviyo-bis-subscribe]');
  if (!form) return;
  var titleEl = modal.querySelector('[data-klaviyo-bis-product-title]');
  var variantPicker = modal.querySelector('[data-klaviyo-bis-variant-picker]');
  var variantSelect = modal.querySelector('#klaviyo-bis-variant-select');
  var emailInput = modal.querySelector('[data-klaviyo-bis-email]');
  var submitBtn = modal.querySelector('[data-klaviyo-bis-submit]');
  var errorEl = modal.querySelector('[data-klaviyo-bis-error]');
  var successEl = modal.querySelector('[data-klaviyo-bis-success]');
  var currentVariantId = null;

  function resetModal() {
    form.classList.remove('hidden');
    successEl.classList.add('hidden');
    errorEl.classList.add('hidden');
    errorEl.textContent = '';
    emailInput.value = '';
    if (submitBtn) submitBtn.disabled = false;
  }

  modal.addEventListener('open.hs.overlay', function() {
    resetModal();
  });

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-klaviyo-bis-open]');
    if (!trigger) return;

    var title = trigger.dataset.productTitle || '';
    var variants = trigger.dataset.variants || '[]';

    titleEl.textContent = title;

    try {
      var parsed = JSON.parse(variants);
      if (!Array.isArray(parsed)) parsed = [parsed];
      if (parsed.length > 1) {
        var unavailable = parsed.filter(function(v) { return !v.available; });
        var selectHTML = '';
        var firstUnavailableId = null;

        unavailable.forEach(function(v) {
          if (!firstUnavailableId) firstUnavailableId = v.id;
          selectHTML += '<option value="' + v.id + '">' + v.title + '</option>';
        });

        if (selectHTML) {
          variantSelect.innerHTML = selectHTML;
          currentVariantId = firstUnavailableId;
          variantPicker.classList.remove('hidden');
        } else {
          variantPicker.classList.add('hidden');
          currentVariantId = parsed[0].id;
        }
      } else {
        variantPicker.classList.add('hidden');
        currentVariantId = parsed[0] ? parsed[0].id : null;
      }
    } catch (err) {
      variantPicker.classList.add('hidden');
      currentVariantId = null;
    }
  });

  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      currentVariantId = this.value;
    });
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var email = emailInput.value.trim();
    if (!currentVariantId) {
      errorEl.textContent = 'Unable to identify the product variant. Please close and reopen this window.';
      errorEl.classList.remove('hidden');
      return;
    }
    if (!email) return;

    errorEl.classList.add('hidden');
    if (submitBtn) submitBtn.disabled = true;

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + klaviyoKey, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'revision': '2024-02-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: '$shopify:::$default:::' + currentVariantId
              }
            }
          }
        }
      })
    })
    .then(function(res) {
      // Klaviyo returns 202 with an empty body on success
      return res.text().then(function(text) {
        var data = null;
        if (text) {
          try { data = JSON.parse(text); } catch (err) { data = null; }
        }
        return { ok: res.ok, data: data };
      });
    })
    .then(function(result) {
      if (!result.ok || (result.data && result.data.errors && result.data.errors.length > 0)) {
        var msg = 'Something went wrong. Please try again.';
        if (result.data && result.data.errors && result.data.errors.length > 0) {
          msg = result.data.errors.map(function(e) { return e.detail || e.title || 'Error'; }).join(', ');
        }
        errorEl.textContent = msg;
        errorEl.classList.remove('hidden');
        if (submitBtn) submitBtn.disabled = false;
      } else {
        form.classList.add('hidden');
        successEl.classList.remove('hidden');
      }
    })
    .catch(function(err) {
      console.error('Klaviyo BIS error:', err);
      errorEl.textContent = 'Something went wrong. Please try again.';
      errorEl.classList.remove('hidden');
      if (submitBtn) submitBtn.disabled = false;
    });
  });
});


/***/ },

/***/ 313
() {

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const quickAddBtn = e.target.closest('[data-quick-add-button]');
    if (!quickAddBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = quickAddBtn.dataset.variantId;
    const btnText = quickAddBtn.querySelector('[data-quick-add-text]');
    const btnIcon = quickAddBtn.querySelector('svg');
    const originalText = btnText ? btnText.textContent : '';

    quickAddBtn.classList.add('quick-add-loading');
    quickAddBtn.disabled = true;

    // Start spinning animation on icon
    if (btnIcon) {
      btnIcon.classList.add('quick-add-spin');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId),
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      quickAddBtn.classList.remove('quick-add-loading');
      quickAddBtn.disabled = false;

      if (data.id) {
        // Stop spinning and add success animation
        if (btnIcon) {
          btnIcon.classList.remove('quick-add-spin');
          btnIcon.classList.add('quick-add-success');
        }
        quickAddBtn.classList.add('quick-add-success-btn');

        if (btnText) btnText.textContent = 'Added!';

        // Update cart count if it exists
        const cartCount = document.querySelector('[data-cart-count]');
        if (cartCount) {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              cartCount.textContent = cart.item_count;
            });
        }

        // Trigger cart build to refresh cart content
        document.dispatchEvent(new CustomEvent('cart:build'));

        // Open cart drawer if it exists
        // Use custom event instead of clicking the trigger to avoid focus issues
        if (typeof theme !== 'undefined' && theme.CartDrawer) {
          document.dispatchEvent(new CustomEvent('cart:open'));
        } else {
          // Fallback: trigger cart drawer open without focusing the trigger element
          const cartDrawerTrigger = document.querySelector('.js-drawer-open-cart');
          if (cartDrawerTrigger) {
            // Store current scroll position
            const scrollY = window.scrollY;
            cartDrawerTrigger.click();
            // Restore scroll position after a tiny delay
            requestAnimationFrame(() => {
              window.scrollTo(0, scrollY);
            });
          }
        }

        setTimeout(() => {
          if (btnText) btnText.textContent = originalText;
          if (btnIcon) {
            btnIcon.classList.remove('quick-add-success');
          }
          quickAddBtn.classList.remove('quick-add-success-btn');
        }, 2000);
      } else {
        // Stop spinning on error
        if (btnIcon) {
          btnIcon.classList.remove('quick-add-spin');
        }
        if (btnText) btnText.textContent = 'Error';
        setTimeout(() => {
          if (btnText) btnText.textContent = originalText;
        }, 2000);
      }
    })
    .catch(error => {
      console.error('Error:', error);
      quickAddBtn.classList.remove('quick-add-loading');
      quickAddBtn.disabled = false;
      if (btnIcon) {
        btnIcon.classList.remove('quick-add-spin');
      }
      if (btnText) btnText.textContent = originalText;
    });
  });
});

/***/ }

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";

;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/userAgent.js
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js








function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/createPopper.js









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/(/* unused pure expression or super */ null && (popperGenerator())); // eslint-disable-next-line import/no-unused-modules


;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function applyStyles_effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: applyStyles_effect,
  requires: ['computeStyles']
});
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js




function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/arrow.js








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ const modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// ./node_modules/.pnpm/@popperjs+core@2.11.8/node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


;// ./_src/scripts/preline/core/component.js
/*
 * Component
 * @version: 1.3.0
 * @author: HtmlStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 Htmlstream
 */

class Component {
  constructor(selector, config) {
    this.$collection = [];
    this.selector = selector;
    this.config = config;
    this.events = {};
  }

  _fireEvent(eventType, payload = null) {
    if (this.events.hasOwnProperty(eventType)) {
      this.events[eventType](payload);
    }
  }

  _dispatch(eventType, element, payload = null) {
    const event = new CustomEvent(eventType, {
      detail: { payload },
      bubbles: true,
      cancelable: true,
      composed: false,
    });
    element.dispatchEvent(event);
  }

  on(eventType, callback) {
    this.events[eventType] = callback;
  }

  afterTransition($element, callback) {
    const handleEvent = () => {
      callback();
      $element.removeEventListener('transitionend', handleEvent, true);
    };

    if (window.getComputedStyle($element, null).getPropertyValue('transition') !== 'all 0s ease 0s') {
      $element.addEventListener('transitionend', handleEvent, true);
    } else {
      callback();
    }
  }

  getClassProperty($element, propertyName, defaultValue = '') {
    const value = (window.getComputedStyle($element).getPropertyValue(propertyName) || defaultValue).replace(' ', '');

    return value;
  }
}

;// ./_src/scripts/preline/utils/menusearchhistory.js
/*
 * Util
 * @version: 1.3.0
 * @author: HtmlStream
 * @license: Licensed under MIT (https://preline.co/docs/license.html)
 * Copyright 2023 Htmlstream
 */

/* harmony default export */ const menusearchhistory = ({
  historyIndex: -1,

  addHistory(index) {
    this.historyIndex = index;
  },

  existsInHistory(index) {
    return index > this.historyIndex;
  },

  clearHistory() {
    this.historyIndex = -1;
  },
});

;// ./_src/scripts/components/dropdown/index.js
/*
 * Dropdown
 */





const isIOS = () => {
  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
  }
};

const isIpadOS = () => {
  return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
};

class HSDropdown extends Component {
  constructor() {
    super('.hs-dropdown');

    this.positions = {
      top: 'top',
      'top-left': 'top-start',
      'top-right': 'top-end',
      bottom: 'bottom',
      'bottom-left': 'bottom-start',
      'bottom-right': 'bottom-end',
      right: 'right',
      'right-top': 'right-start',
      'right-bottom': 'right-end',
      left: 'left',
      'left-top': 'left-start',
      'left-bottom': 'left-end',
    };
    this.absoluteStrategyModifiers = ($dropdownEl) => {
      return [
        {
          name: 'applyStyles',
          fn: (data) => {
            const strategy = (
              window.getComputedStyle($dropdownEl).getPropertyValue('--strategy') || 'absolute'
            ).replace(' ', '');
            const adaptive = (
              window.getComputedStyle($dropdownEl).getPropertyValue('--adaptive') || 'adaptive'
            ).replace(' ', '');

            data.state.elements.popper.style.position = strategy;
            data.state.elements.popper.style.transform =
              adaptive === 'adaptive' ? data.state.styles.popper.transform : null;
            data.state.elements.popper.style.top = null;
            data.state.elements.popper.style.bottom = null;
            data.state.elements.popper.style.left = null;
            data.state.elements.popper.style.right = null;
            data.state.elements.popper.style.margin = 0;
          },
        },
        {
          name: 'computeStyles',
          options: {
            adaptive: false,
          },
        },
      ];
    };
    this._history = menusearchhistory;
  }

  init() {
    document.addEventListener('click', (e) => {
      const $targetEl = e.target;
      const $dropdownEl = $targetEl.closest(this.selector);
      const $menuEl = $targetEl.closest('.hs-dropdown-menu');

      if (!$dropdownEl || !$dropdownEl.classList.contains('open')) this._closeOthers($dropdownEl);

      if ($menuEl) {
        const autoClose = (window.getComputedStyle($dropdownEl).getPropertyValue('--auto-close') || '').replace(
          ' ',
          ''
        );
        if ((autoClose == 'false' || autoClose == 'inside') && !$dropdownEl.parentElement.closest(this.selector))
          return;
      }

      if ($dropdownEl) {
        !$dropdownEl.classList.contains('open') ? this.open($dropdownEl) : this.close($dropdownEl);
      }
    });

    document.addEventListener('mousemove', (e) => {
      const $targetEl = e.target;
      const $dropdownEl = $targetEl.closest(this.selector);
      const $menuEl = $targetEl.closest('.hs-dropdown-menu');

      if ($dropdownEl) {
        const trigger = (window.getComputedStyle($dropdownEl).getPropertyValue('--trigger') || 'click').replace(
          ' ',
          ''
        );
        if (trigger !== 'hover') return;

        if (!$dropdownEl || !$dropdownEl.classList.contains('open')) this._closeOthers($dropdownEl);
        if (trigger === 'hover' && !$dropdownEl.classList.contains('open') && !isIOS() && !isIpadOS())
          this._hover($targetEl);
      }

    });

    document.addEventListener('keydown', this._keyboardSupport.bind(this));

    window.addEventListener('resize', () => {
      const dropdownEls = document.querySelectorAll('.hs-dropdown.open');
      dropdownEls.forEach(($dropdownEl) => {
        this.close($dropdownEl, true);
      });
    });
  }

  _closeOthers($currentDropdownEl = null) {
    const $collection = document.querySelectorAll(`${this.selector}.open`);
    $collection.forEach(($dropdownEl) => {
      if ($currentDropdownEl && $currentDropdownEl.closest('.hs-dropdown.open') === $dropdownEl) return;

      const autoClose = (window.getComputedStyle($dropdownEl).getPropertyValue('--auto-close') || '').replace(' ', '');
      if (autoClose == 'false' || autoClose == 'outside') return;

      this.close($dropdownEl);
    });
  }

  _hover($targetEl) {
    const $dropdownEl = $targetEl.closest(this.selector);

    this.open($dropdownEl);

    const handleMousmove = (e) => {
      if (
        !e.target.closest(this.selector) ||
        e.target.closest(this.selector) === $dropdownEl.parentElement.closest(this.selector)
      ) {
        this.close($dropdownEl);
        document.removeEventListener('mousemove', handleMousmove, true);
      }
    };

    document.addEventListener('mousemove', handleMousmove, true);
  }

  close($dropdownEl, noAnimation = false) {
    const $menuEl = $dropdownEl.querySelector('.hs-dropdown-menu');

    const destroy = () => {
      if ($dropdownEl.classList.contains('open')) return;
      $menuEl.classList.remove('block');
      $menuEl.classList.add('hidden');
      $menuEl.style.inset = null;
      $menuEl.style.position = null;

      if ($dropdownEl._popper) {
        $dropdownEl._popper.destroy();
      }
    };

    if (!noAnimation) {
      this.afterTransition($dropdownEl.querySelector('[data-hs-dropdown-transition]') || $menuEl, () => {
        destroy();
      });
    }

    $menuEl.style.margin = null;
    $dropdownEl.classList.remove('open');

    if (noAnimation) {
      destroy();
    }

    this._fireEvent('close', $dropdownEl);
    this._dispatch('close.hs.dropdown', $dropdownEl, $dropdownEl);

    const dropdownEls = $menuEl.querySelectorAll('.hs-dropdown.open');
    dropdownEls.forEach(($dropdownEl) => {
      this.close($dropdownEl, true);
    });
  }

  open($dropdownEl) {
    const $menuEl = $dropdownEl.querySelector('.hs-dropdown-menu');
    const placement = (window.getComputedStyle($dropdownEl).getPropertyValue('--placement') || '').replace(' ', '');
    const strategy = (window.getComputedStyle($dropdownEl).getPropertyValue('--strategy') || 'fixed').replace(' ', '');
    const adaptive = (window.getComputedStyle($dropdownEl).getPropertyValue('--adaptive') || 'adaptive').replace(
      ' ',
      ''
    );
    const offset = parseInt(
      (window.getComputedStyle($dropdownEl).getPropertyValue('--offset') || '10').replace(' ', '')
    );

    if (strategy !== 'static') {
      if ($dropdownEl._popper) {
        $dropdownEl._popper.destroy();
      }

      const $popper = popper_createPopper($dropdownEl, $menuEl, {
        placement: this.positions[placement] || 'bottom-start',
        strategy: strategy,
        modifiers: [
          ...(strategy !== 'fixed' ? this.absoluteStrategyModifiers($dropdownEl) : []),
          {
            name: 'offset',
            options: {
              offset: [0, offset],
            },
          },
        ],
      });

      $dropdownEl._popper = $popper;
    }

    $menuEl.style.margin = null;
    $menuEl.classList.add('block');
    $menuEl.classList.remove('hidden');

    setTimeout(() => {
      $dropdownEl.classList.add('open');
    });

    this._fireEvent('open', $dropdownEl);
    this._dispatch('open.hs.dropdown', $dropdownEl, $dropdownEl);
  }

  _keyboardSupport(e) {
    const $dropdownEl = document.querySelector('.hs-dropdown.open');
    if (!$dropdownEl) return;

    if (e.keyCode === 27) {
      e.preventDefault();
      return this._esc($dropdownEl);
    }
    if (e.keyCode === 40) {
      e.preventDefault();
      return this._down($dropdownEl);
    }
    if (e.keyCode === 38) {
      e.preventDefault();
      return this._up($dropdownEl);
    }

    if (e.keyCode === 36) {
      e.preventDefault();
      return this._start($dropdownEl);
    }

    if (e.keyCode === 35) {
      e.preventDefault();
      return this._end($dropdownEl);
    }

    this._byChar($dropdownEl, e.key);
  }

  _esc($dropdownEl) {
    this.close($dropdownEl);
  }

  _up($dropdownEl) {
    const $menuEl = $dropdownEl.querySelector('.hs-dropdown-menu');
    const links = [...$menuEl.querySelectorAll('a')].reverse().filter(($linkEl) => !$linkEl.disabled);
    const $activeLinkEl = $menuEl.querySelector('a:focus');
    let acitveIndex = links.findIndex(($linkEl) => $linkEl === $activeLinkEl);

    if (acitveIndex + 1 < links.length) {
      acitveIndex++;
    }

    links[acitveIndex].focus();
  }

  _down($dropdownEl) {
    const $menuEl = $dropdownEl.querySelector('.hs-dropdown-menu');
    const links = [...$menuEl.querySelectorAll('a')].filter(($linkEl) => !$linkEl.disabled);
    const $activeLinkEl = $menuEl.querySelector('a:focus');
    let acitveIndex = links.findIndex(($linkEl) => $linkEl === $activeLinkEl);

    if (acitveIndex + 1 < links.length) {
      acitveIndex++;
    }

    links[acitveIndex].focus();
  }

  _start($dropdownEl) {
    const $menuEl = $dropdownEl.querySelector('.hs-dropdown-menu');
    const links = [...$menuEl.querySelectorAll('a')].filter(($linkEl) => !$linkEl.disabled);

    if (links.length) {
      links[0].focus();
    }
  }

  _end($dropdownEl) {
    const $menuEl = $dropdownEl.querySelector('.hs-dropdown-menu');
    const links = [...$menuEl.querySelectorAll('a')].reverse().filter(($linkEl) => !$linkEl.disabled);

    if (links.length) {
      links[0].focus();
    }
  }

  _byChar($dropdownEl, char) {
    const $menuEl = $dropdownEl.querySelector('.hs-dropdown-menu');
    const links = [...$menuEl.querySelectorAll('a')];
    const getActiveIndex = () => {
      return links.findIndex(
        ($linkEl, index) =>
          $linkEl.innerText.toLowerCase().charAt(0) === char.toLowerCase() && this._history.existsInHistory(index)
      );
    };

    let acitveIndex = getActiveIndex();

    if (acitveIndex === -1) {
      this._history.clearHistory();
      acitveIndex = getActiveIndex();
    }

    if (acitveIndex !== -1) {
      links[acitveIndex].focus();
      this._history.addHistory(acitveIndex);
    }
  }

  toggle($dropdownEl) {
    $dropdownEl.classList.contains('open') ? this.close($dropdownEl) : this.open($dropdownEl);
  }
}

window.HSDropdown = new HSDropdown();
document.addEventListener('load', window.HSDropdown.init());

;// ./_src/scripts/components/collapse/index.js
/*
 * Collapse
 */



class HSCollapse extends Component {
  constructor() {
    super('[data-hs-collapse]');
  }

  init() {
    document.addEventListener('click', (e) => {
      const $targetEl = e.target;
      const $collapseToggleEl = $targetEl.closest(this.selector);

      if ($collapseToggleEl) {
        const collapseEls = document.querySelectorAll($collapseToggleEl.getAttribute('data-hs-collapse'));

        this.toggle(collapseEls);
      }
    });
  }

  toggle($collapseEls) {
    if (!$collapseEls.length) return;

    [...$collapseEls].forEach(($collapseEl) => {
      $collapseEl.classList.contains('hidden') ? this.show($collapseEl) : this.hide($collapseEl);
    });
  }

  show($collapseEl) {
    $collapseEl.classList.add('open');
    $collapseEl.classList.remove('hidden');
    $collapseEl.style.height = 0;

    document.querySelectorAll(this.selector).forEach(($toggleEl) => {
      if ($collapseEl.closest($toggleEl.getAttribute('data-hs-collapse'))) {
        $toggleEl.classList.add('open');
      }
    });

    $collapseEl.style.height = `${$collapseEl.scrollHeight}px`;

    this.afterTransition($collapseEl, () => {
      if (!$collapseEl.classList.contains('open')) return;

      $collapseEl.style.height = '';

      this._fireEvent('open', $collapseEl);
      this._dispatch('open.hs.collapse', $collapseEl, $collapseEl);
    });
  }

  hide($collapseEl) {
    $collapseEl.style.height = `${$collapseEl.scrollHeight}px`;

    setTimeout(() => {
      $collapseEl.style.height = 0;
    });

    $collapseEl.classList.remove('open');

    this.afterTransition($collapseEl, () => {
      if ($collapseEl.classList.contains('open')) return;
      $collapseEl.classList.add('hidden');
      $collapseEl.style.height = null;

      this._fireEvent('hide', $collapseEl);
      this._dispatch('hide.hs.collapse', $collapseEl, $collapseEl);

      $collapseEl.querySelectorAll('.hs-mega-menu-content.block').forEach(($megaMenuEl) => {
        $megaMenuEl.classList.remove('block');
        $megaMenuEl.classList.add('hidden');
      });
    });

    document.querySelectorAll(this.selector).forEach(($toggleEl) => {
      if ($collapseEl.closest($toggleEl.getAttribute('data-hs-collapse'))) {
        $toggleEl.classList.remove('open');
      }
    });
  }
}

window.HSCollapse = new HSCollapse();
document.addEventListener('load', window.HSCollapse.init());

;// ./_src/scripts/components/accordion/index.js
/*
 * Accordion
 */



class HSAccordion extends Component {
  constructor() {
    super('.hs-accordion');
  }

  init() {
    document.addEventListener('click', (e) => {
      const $targetEl = e.target;
      const $accordionEl = $targetEl.closest(this.selector);
      const $accordionToggleEl = $targetEl.closest('.hs-accordion-toggle');
      const $accordionGroupEl = $targetEl.closest('.hs-accordion-group');
      if ($accordionEl && $accordionGroupEl && $accordionToggleEl) {
        this._hideAll($accordionEl);

        this.show($accordionEl);
      }
    });
  }

  show($accordionEl) {
    if ($accordionEl.classList.contains('active')) {
      return this.hide($accordionEl);
    }

    $accordionEl.classList.add('active');

    const $accordionContentEl = $accordionEl.querySelector('.hs-accordion-content');

    $accordionContentEl.style.display = 'block';
    $accordionContentEl.style.height = 0;
    setTimeout(() => {
      $accordionContentEl.style.height = `${$accordionContentEl.scrollHeight}px`;
    });

    this.afterTransition($accordionContentEl, () => {
      if (!$accordionEl.classList.contains('active')) return;
      $accordionContentEl.style.height = '';

      this._fireEvent('open', $accordionEl);
      this._dispatch('open.hs.accordion', $accordionEl, $accordionEl);
    });
  }

  hide($accordionEl) {
    const $accordionContentEl = $accordionEl.querySelector('.hs-accordion-content');

    $accordionContentEl.style.height = `${$accordionContentEl.scrollHeight}px`;
    setTimeout(() => {
      $accordionContentEl.style.height = 0;
    });

    this.afterTransition($accordionContentEl, () => {
      if ($accordionEl.classList.contains('active')) return;
      $accordionContentEl.style.display = '';

      this._fireEvent('hide', $accordionEl);
      this._dispatch('hide.hs.accordion', $accordionEl, $accordionEl);
    });

    $accordionEl.classList.remove('active');
  }

  _hideAll($currentaccordionEl) {
    const $accordionGroupEl = $currentaccordionEl.closest('.hs-accordion-group');

    if ($accordionGroupEl.hasAttribute('data-hs-accordion-always-open')) return;

    $accordionGroupEl.querySelectorAll(this.selector).forEach(($accordionEl) => {
      if ($currentaccordionEl !== $accordionEl) {
        this.hide($accordionEl);
      }
    });
  }
}

window.HSAccordion = new HSAccordion();
document.addEventListener('load', window.HSAccordion.init());

;// ./_src/scripts/components/overlay/index.js
/*
 * Overlay
 */



class HSOverlay extends Component {
  constructor() {
    super('[data-hs-overlay]');

    this.openNextOverlay = false;
  }

  init() {
    document.addEventListener('click', (e) => {
      const $targetEl = e.target;
      const $overlayToggleEl = $targetEl.closest(this.selector);
      const $closeOverlayTriggerEl = e.target.closest('[data-hs-overlay-close]');
      const $openedOverlayEl = e.target.getAttribute('aria-overlay') === 'true';

      if ($closeOverlayTriggerEl) {
        return this.close($closeOverlayTriggerEl.closest('.hs-overlay.open'));
      }

      if ($overlayToggleEl) {
        return this.toggle(document.querySelector($overlayToggleEl.getAttribute('data-hs-overlay')));
      }

      if ($openedOverlayEl) {
        this._onBackdropClick(e.target);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        const $openedOverlayEl = document.querySelector('.hs-overlay.open');
        if (!$openedOverlayEl) return;

        setTimeout(() => {
          $openedOverlayEl.getAttribute('data-hs-overlay-keyboard') !== 'false' ? this.close($openedOverlayEl) : null;
        });
      }
    });
  }

  toggle($overlayEl) {
    if (!$overlayEl) return;

    $overlayEl.classList.contains('hidden') ? this.open($overlayEl) : this.close($overlayEl);
  }

  open($overlayEl) {
    if (!$overlayEl) return;

    const $openedOverlayEl = document.querySelector('.hs-overlay.open');
    const disabledScroll = this.getClassProperty($overlayEl, '--body-scroll', 'false') !== 'true';

    if ($openedOverlayEl) {
      this.openNextOverlay = true;
      return this.close($openedOverlayEl).then(() => {
        this.open($overlayEl);
        this.openNextOverlay = false;
      });
    }

    if (disabledScroll) {
      document.body.style.overflow = 'hidden';
    }

    this._buildBackdrop($overlayEl);
    this._checkTimer($overlayEl);
    this._autoHide($overlayEl);

    $overlayEl.classList.remove('hidden');
    $overlayEl.setAttribute('aria-overlay', 'true');
    $overlayEl.setAttribute('tabindex', '-1');

    setTimeout(() => {
      if ($overlayEl.classList.contains('hidden')) return;
      $overlayEl.classList.add('open');
      this._fireEvent('open', $overlayEl);
      this._dispatch('open.hs.overlay', $overlayEl, $overlayEl);
      this._focusInput($overlayEl);
    }, 50);
  }

  close($overlayEl) {
    return new Promise((resolve) => {
      if (!$overlayEl) return;

      $overlayEl.classList.remove('open');
      $overlayEl.removeAttribute('aria-overlay');
      $overlayEl.removeAttribute('tabindex', '-1');

      this.afterTransition($overlayEl, () => {
        if ($overlayEl.classList.contains('open')) return;
        $overlayEl.classList.add('hidden');
        this._destroyBackdrop();
        this._fireEvent('close', $overlayEl);
        this._dispatch('close.hs.overlay', $overlayEl, $overlayEl);
        document.body.style.overflow = '';
        resolve($overlayEl);
      });
    });
  }

  _autoHide($overlayEl) {
    const time = parseInt(this.getClassProperty($overlayEl, '--auto-hide', '0'));

    if (time) {
      $overlayEl.autoHide = setTimeout(() => {
        this.close($overlayEl);
      }, time);
    }
  }

  _checkTimer($overlayEl) {
    if ($overlayEl.autoHide) {
      clearTimeout($overlayEl.autoHide);
      delete $overlayEl.autoHide;
    }
  }

  _onBackdropClick($overlayEl) {
    const closeOnBackdrop = this.getClassProperty($overlayEl, '--overlay-backdrop', 'true') !== 'static';

    if (closeOnBackdrop) {
      this.close($overlayEl);
    }
  }

  _buildBackdrop($overlayEl) {
    const backdropSelector = $overlayEl.getAttribute('data-hs-overlay-backdrop-container') || false;
    let $backdropEl = document.createElement('div');
    let backdropClasses = 'transition duration fixed inset-0 z-50 bg-gray-900 bg-opacity-50';
    const backdropCount = document.querySelectorAll('[data-hs-overlay-backdrop-template]').length;
    const closeOnBackdrop = this.getClassProperty($overlayEl, '--overlay-backdrop', 'true') !== 'static';
    const disableBackdrop = this.getClassProperty($overlayEl, '--overlay-backdrop', 'true') === 'false';

    if (backdropCount > 1 || disableBackdrop) return;

    if (backdropSelector) {
      $backdropEl = document.querySelector(backdropSelector).cloneNode(true);
      $backdropEl.classList.remove('hidden');
      backdropClasses = $backdropEl.classList;
      $backdropEl.classList = '';
    }

    if (closeOnBackdrop) {
      $backdropEl.addEventListener('click', () => this.close($overlayEl), true);
    }

    $backdropEl.setAttribute('data-hs-overlay-backdrop-template', '');
    document.body.appendChild($backdropEl);

    setTimeout(() => {
      $backdropEl.classList = backdropClasses;
    });
  }

  _destroyBackdrop() {
    const $backdropEl = document.querySelector('[data-hs-overlay-backdrop-template]');

    if (!$backdropEl) return;

    if (this.openNextOverlay) {
      $backdropEl.style.transitionDuration = `${
        parseFloat(window.getComputedStyle($backdropEl).transitionDuration.replace(/[^\d.-]/g, '')) * 1.8
      }s`;
    }

    $backdropEl.classList.add('opacity-0');

    this.afterTransition($backdropEl, () => {
      $backdropEl.remove();
    });
  }

  _focusInput($overlayEl) {
    const $inputWithAutoFocusEl = $overlayEl.querySelector('[autofocus]');
    if ($inputWithAutoFocusEl) $inputWithAutoFocusEl.focus();
  }
}

window.HSOverlay = new HSOverlay();
document.addEventListener('load', window.HSOverlay.init());

;// ./_src/scripts/components/multi-level/index.js
/*
 * MultiLevel
 */



class HSMultiLevel extends Component {
  constructor() {
    super('.hs-multilevel');
  }

  init() {
    document.addEventListener('click', (e) => {
      const $targetEl = e.target;
      const $multiMenuEl = $targetEl.closest(this.selector);
      const $multiMenuToggleEl = $targetEl.closest('.hs-multilevel-toggle');
      const $multiMenuGroupEl = $targetEl.closest('.hs-multilevel-group');
      if ($multiMenuEl && $multiMenuGroupEl && $multiMenuToggleEl) {
        this._hideAll($multiMenuEl);

        this.show($multiMenuEl);
      }
    });
  }

  show($multiMenuEl) {
    if ($multiMenuEl.classList.contains('active')) {
      return this.hide($multiMenuEl);
    }

    $multiMenuEl.classList.add('active');

    const $multiMenuContentEl = $multiMenuEl.querySelector('.hs-multilevel-content');

    $multiMenuContentEl.classList.remove('hidden');
    // $overlayEl.setAttribute('tabindex', '-1');

    // setTimeout(() => {
    //   // $multiMenuContentEl.style.height = `${$multiMenuContentEl.scrollHeight}px`;
    //   $multiMenuContentEl.classList.add('h-screen', 'translate-x-0');
    // });

    this.afterTransition($multiMenuContentEl, () => {
      if (!$multiMenuEl.classList.contains('active')) return;
      // $multiMenuContentEl.style.height = '';

      this._fireEvent('open', $multiMenuEl);
      this._dispatch('open.hs.multilevel', $multiMenuEl, $multiMenuEl);
    });
  }

  hide($multiMenuEl) {
    const $multiMenuContentEl = $multiMenuEl.querySelector('.hs-multilevel-content');

    // $multiMenuContentEl.style.height = `${$multiMenuContentEl.scrollHeight}px`;
    $multiMenuContentEl.classList.remove('h-screen', 'translate-x-0');

    setTimeout(() => {
      $multiMenuContentEl.classList.add('hidden' );
      // $multiMenuContentEl.style.height = 0;
    });

    this.afterTransition($multiMenuContentEl, () => {
      if ($multiMenuEl.classList.contains('active')) return;
      $multiMenuContentEl.style.display = '';

      this._fireEvent('hide', $multiMenuEl);
      this._dispatch('hide.hs.multilevel', $multiMenuEl, $multiMenuEl);
    });

    $multiMenuEl.classList.remove('active');
  }

  _hideAll($currentaccordionEl) {
    const $multiMenuGroupEl = $currentaccordionEl.closest('.hs-multilevel-group');

    if ($multiMenuGroupEl.hasAttribute('data-hs-multilevel-always-open')) return;

    $multiMenuGroupEl.querySelectorAll(this.selector).forEach(($multiMenuEl) => {
      if ($currentaccordionEl !== $multiMenuEl) {
        this.hide($multiMenuEl);
      }
    });
  }
}

window.HSMultiLevel = new HSMultiLevel();
document.addEventListener('load', window.HSMultiLevel.init());

// EXTERNAL MODULE: ./_src/scripts/components/product-card-quick-add.js
var product_card_quick_add = __webpack_require__(313);
// EXTERNAL MODULE: ./_src/scripts/components/klaviyo-bis-trigger.js
var klaviyo_bis_trigger = __webpack_require__(52);
;// ./_src/scripts/base.js








})();

/******/ })()
;